export const COLUMNSOLICITUD = [
  {
    accessorKey: "id",
  },
  {
    header: "Solicitud",
    accessorKey: "solicitud",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Mensaje",
    accessorKey: "mensaje",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
]
